<template>
    <div class="single-answer">
        <div class="q-privew" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
            <div class="q-number" v-if="currentQuestion.questionNo">Q {{currentQuestion.questionNo}}</div>
            <div class="q-number-Suggestions" v-if="currentQuestion.suggestions">Suggestions {{currentQuestion.suggestions}} </div>
            <div  @contextmenu="rightClickDisable($event)" class="q-type"  :class="{'question-font':!questionFont(currentQuestion)}" v-html="currentQuestion.question_text"></div>
           <div class="pyq-tag-section" v-if="showPyqButton" style="margin-top: 10px; white-space: nowrap;">
                <div
                    v-for="(tag, index) in pyqTags"
                    :key="index"
                    class="pyq-card"
                    style="display: inline-block; margin-right: 8px;"
                >
                    <div class="pyq-btn" style="background-color: #039be5; color: white; padding: 6px 16px; border-radius: 4px; border: 1px solid #039be5; min-width: 60px; text-align: center;">
                        {{ tag }}
                    </div>
                </div>
            </div>
        </div>
        <div class="col-ans-row" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
            <div class="col-i">
                <div class="col-title-center">Column I</div>
                <div
                    class="q-privew"
                    v-for="option in currentQuestion.options_abc"
                    :key="option.id"
                >
                    <div class="q-number">{{option.index}}</div>
                    <div class="q-type" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="option.option_text"></div>
                </div>
            </div>
            <div class="col-i">
                <div class="col-title-center">Column II</div>
                <div
                    class="q-privew"
                    v-for="option in currentQuestion.options_pqr"
                    :key="option.id"
                >
                    <div class="q-number" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">{{option.index}}</div>
                    <div class="q-type" v-html="option.option_text"></div>
                </div>
            </div>
        </div>

        <div class="privew-que" v-if="showAnswerField" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
            <div class="que-row matrix-top">
                <div class="matrix-match-block">
                    <div class="matrix-col">
                        <div class="mt-data">&nbsp;</div>
                        <div
                            v-for="(opt,qindex) in currentQuestion.options_abc"
                            :key="qindex"
                            class="mt-data mt-label"
							@copy.prevent @contextmenu="rightClickDisable($event)"
                            @mouseup="rightClickDisable($event)"
                        >{{opt.index}}</div>
                    </div>
                    <div
                        v-for="(pqr,opindex) in currentQuestion.options_pqr"
                        :key="opindex"
                        class="matrix-col"
                    >
                        <div class="mt-data mt-label" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">{{pqr.index}}</div>
                        <div
                            v-for="(abc,qindex) in currentQuestion.options_abc"
                            :key="qindex"
                            class="mt-data"
                        >
                            <div class="check-cust">
                                <div class="private-radio">
                                    <input
                                        type="checkbox"
                                        :checked="abc.correct_answer.includes(pqr.index)"
                                        :disabled="currentQuestion.disabled"
                                        @change="onChangeInput($event,pqr,abc)"
                                    />
                                    <i
                                        v-if="abc.correct_answer.includes(pqr.index)"
                                        aria-hidden="true"
                                        class="v-icon mdi mdi-checkbox-marked theme--light"
                                        :class="currentQuestion.yourAnswer ? correctAnswer(currentQuestion,abc,pqr) ? ' green--text' : ' red--text' : currentQuestion.isPreview ? ' green--text': abc.correct_answer.includes(pqr.index) && 'blue--text'"
                                    ></i>
                                    <i
                                        v-else
                                        aria-hidden="true"
                                        class="v-icon mdi mdi-checkbox-blank-outline theme--light"
                                    ></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="test-solution">
            <div v-if="isPastTest">
                <!-- ansStatus: {{currentQuestion.ansStatus}} -->
                <div>
                    <v-row>
                        <v-col cols="5"><label class="ans-text-3may">Your Answer: </label>{{currentQuestion.yourAnswer}}
                            <span v-if="currentQuestion.isBonus">
                                ({{ BONUS_MESSAGE }})
                            </span>
                        </v-col>
                        <v-col cols="6"><label class="ans-text-3may">Correct Answer: </label>{{currentQuestion.correctAnswer}}</v-col>
                        
                    </v-row>
                    <!-- <v-row>
                        <v-col cols="2">Hint:</v-col>
                        <v-col cols="10">
                            <div v-html="currentQuestion.hint"></div>
                        </v-col>
                    </v-row>-->
                    <v-row
                        v-if="currentQuestion.solutionVideos && currentQuestion.solutionVideos.length"
                    >
                        <v-col cols="12">Video Solution:</v-col>
                        <v-col
                            cols="10"
                            v-for="video in currentQuestion.solutionVideos"
                            :key="video.id"
                        >
                            <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
                                <video height="100" width="150" controls>
                                    <source :src="video.video_url" />
                                </video>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="no-wrap ans-text-3may" cols="3" sm="1">Solution:</v-col>
                        <v-col cols="9" sm="11">
                            <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <div v-if="(currentQuestion.solution&&currentQuestion.isPreview&& currentQuestion.institute_id === null) || this.currentQuestion.isShowSolution">
                <h5 class="Solution">Solution:</h5>
                <div @copy.prevent  @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
            </div>
			<div v-else-if="(currentQuestion.solution&&currentQuestion.isPreview) || this.currentQuestion.isShowSolution">
                <h5 class="Solution">Solution:</h5>
                <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
    name: "SingleAnsQue",
    props: ["currentQuestion", "showAnswerField","openMandatoryQuePopup", "practiceSessionView"],
    data() {
        return {};
    },
    computed: {
        ...mapGetters("testStore", ["isPastTest"]),
        ...mapState("userStore", ["user", "myInstitute"]),
        showPyqButton() {
            return (
                this.myInstitute?.id === constants.ONLINE_INSTITUTE_ID &&
                this.user?.role_code === 'ST' &&
                this.currentQuestion?.question_tags &&
                this.pyqTags.length > 0
            );
        },
        pyqTags() {
            if (!this.currentQuestion?.question_tags) return [];
            const tags = this.currentQuestion.question_tags.split(',');
            return tags
                .filter(tag => tag.includes('PYQ_'))
                .map(tag => tag.replace('PYQ_', '').trim());
        }
    },
    mounted() {
        this.renderMath();
    },
    methods: {
        ...mapActions({
            setDisableSecondaryAction: "testStore/setDisableSecondaryAction",
        }),
        onChangeInput(e, pqr, abc) {
            if(this.currentQuestion.isAnswerDisabled === true){
                if(this.practiceSessionView!==true){
                    this.openMandatoryQuePopup();
                }
            }else{
                this.setDisableSecondaryAction(true);
                var isAnswered = false;
                if (e.target.checked) {
                    if (!abc.correct_answer.includes(pqr.index)) {
                        let op = abc.correct_answer.split("##");
                        abc.correct_answer = "";
                        if (op.length > 0) {
                            op.map((opt, idx) => {
                                if (idx > 0) {
                                    abc.correct_answer =
                                        abc.correct_answer + "##" + opt;
                                } else {
                                    abc.correct_answer = opt;
                                }
                            });
                        }
                        if (abc.correct_answer.trim().length > 0) {
                            abc.correct_answer =
                                abc.correct_answer + "##" + pqr.index;
                        } else {
                            abc.correct_answer = pqr.index;
                        }
                    }
                } else {
                    if (abc.correct_answer.includes(pqr.index)) {
                        let op = abc.correct_answer.split("##");
                        abc.correct_answer = "";
                        if (op.length > 0) {
                            op.map((opt, idx) => {
                                if (pqr.index != opt) {
                                    if (idx > 0) {
                                        abc.correct_answer =
                                            abc.correct_answer + "##" + opt;
                                    } else {
                                        abc.correct_answer = opt;
                                    }
                                }
                            });
                        }
                    }
                }
                this.$forceUpdate();

                this.currentQuestion.options_abc.forEach((opt) => {
                    if (opt.correct_answer > "") isAnswered = true;
                });
                this.currentQuestion.isAnswered = isAnswered;
            }
        },
        correctAnswer(currentQuestion,abc,pqr){
			let correctAnswer = currentQuestion.correctAnswer.split("|");
			let option = correctAnswer.find(c => c.includes(abc.index))
			let correctOptions = option.split(": ")[1].split(", ").map(c=>c.trim());
			let userCorrectAnswer = abc.correct_answer.split('##');
			if (userCorrectAnswer.includes(pqr.index) && correctOptions.includes(pqr.index)) {
				return true
			}
			return false
		},
        rightClickDisable(e) {
            e.preventDefault();   
        },
    },
    watch: {
        "currentQuestion.id": function (val) {
            this.renderMath();
            this.renderMath();
        },
    },
};
</script>